export const SHOW_WELCOME_MESSAGE = "SHOW_WELCOME_MESSAGE";
export const HIDE_WELCOME_MESSAGE = "HIDE_WELCOME_MESSAGE";
export const SET_INITIAL_PRODUCTS = "SET_INITIAL_PRODUCTS";
